module.exports = __webpack_public_path__ + "img/14.ae479ee2.webp";